import { IJBPPlanning } from '../../models/IJBPPlanning'

export const isFutureYearsPlansPresent = (data: IJBPPlanning[], fyear: number) => {
  return data
    .filter((el) => el.FYear === fyear + 1 || el.FYear === fyear + 2)
    .some(
      (el) =>
        !!el.SellThruSumLCNdp ||
        !!el.SellThruSumLCNet ||
        !!el.SellThruSumUSDNdp ||
        !!el.SellThruSumUSDNet ||
        !!el.SellThruUnits ||
        !!el.SellThruUnitsNdp ||
        !!el.ContractualSumUSDNet ||
        !!el.ContractualSumLCNet ||
        !!el.ContractualUnits ||
        !!el.ContractualSumUSDNdp ||
        !!el.ContractualSumLCNdp ||
        !!el.ContractualUnitsNdp
    )
}
